import techArtImage from '../images/project_techart/coverimg.png';
import vfxImage from '../images/project_vfx/project3_portfolio.png';
import voidstormImage from '../images/project_voidstorm/project4_portfolio.png';
import gameJamsImage from '../images/gamejams.png';
import recruitmentChallengeImage from '../images/challenge.png';
import artImage from '../images/3dart.png';

// Edit this file to update the portfolio copy, project cards, skills, and social links.
// Projects with actionType: 'modal' must set a `modalKey` that matches an entry in
// src/components/Projects/modals/registry.js — each key maps to its own modal
// component with a fully independent layout (see ArtGalleryModal / RecruitmentChallengeModal).
export const siteContent = {
  intro: {
    greeting: "Hi, I'm",
    name: 'Gabriel Flores',
    role: 'Software Engineer & Technical Artist',
    description:
      'I combine engineering and creative problem-solving to build interactive experiences. Currently focused on game development and Technical Art.',
    navigation: [
      { label: 'View Projects', target: 'projects', primary: true },
      { label: 'About Me', target: 'about' },
      { label: 'Skills & Tools', target: 'skills' },
    ],
  },
  about: {
    eyebrow: 'About',
    title: 'Who I Am',
    paragraphs: [
      "I'm a Software Engineer with a Bachelor's degree in Mechatronics Engineering and 7+ years of experience in automation, BPM, and workflow development.",
      "I'm currently pursuing a Master's in Integrated Game Design and Development, specializing in Technical Art, where I combine programming and visual development to create technical and artistic solutions for games.",
    ],
    highlights: [
      { label: 'Based in Mexico', icon: 'location' },
      { label: 'Experience: 7+ years', icon: 'experience' },
      { label: 'Specialization: Technical Art', icon: 'specialization' },
    ],
  },
  projects: {
    eyebrow: 'Projects',
    title: 'What I\'ve Built',
    items: [
      {
        title: 'Folkvangr',
        image: techArtImage,
        tools: ['Unity', 'Blender', 'Krita', 'C#', 'Git'],
        description: 'Real-time VFX, shaders, and environment assets for a fighting game.',
        modalDescription: [
          'As a VFX & Technical Artist at SilverLine Studios, I create real-time visual effects and technical art solutions for Folkvangr, a fighting game inspired by Norse mythology.',
          'My work includes developing combat effects, shaders, materials, and environment assets in Unity, while collaborating with the art and development teams to ensure each effect supports gameplay clarity, visual consistency, and performance.',
        ],
        url: 'https://linktr.ee/Silver.Line.Studios',
        actionLabel: 'View More',
        actionType: 'modal',
        modalKey: 'folkvangr',
      },
      {
        title: 'Game Mechanics & VFX Studio',
        image: vfxImage,
        tools: ['Unity', 'Blender', 'Krita', 'C#'],
        description: 'Recreating iconic gameplay mechanics and VFX to explore Unity systems.',
        url: 'https://x.com/gfdevlab',
        actionLabel: 'View Posts',
        actionType: 'external',
      },
      {
        title: '3D Art & Animations',
        image: artImage,
        tools: ['Blender', 'Maya', 'Substance Painter'],
        description: '3D models, materials, textures, rigs, and animations created for game development.',
        url: '',
        actionLabel: 'View More',
        actionType: 'modal',
        modalKey: 'artGallery',
      },
      {
        title: 'Voidstorm',
        image: voidstormImage,
        tools: ['Unity', 'Blender', 'Krita', 'Firebase'],
        description: 'A fast-paced defense shooter developed in Unity over one month.',
        url: 'https://gabriel-flores.itch.io/voidstorm',
        actionLabel: 'Play Now',
        actionType: 'external',
      },
      {
        title: 'GameJams',
        image: gameJamsImage,
        tools: ['Unity', 'Blender', 'Krita', 'C#'],
        description: 'A collection of games created during game jams, exploring different ideas, mechanics, and styles under tight deadlines.',
        url: 'https://gabriel-flores.itch.io/',
        actionLabel: 'View Games',
        actionType: 'external',
      },
      {
        title: 'Recruitment Challenge',
        image: recruitmentChallengeImage,
        tools: ['Unity', 'Blender', 'Mixamo', 'Shader Graph', 'Particle Systems'],
        description: 'A 6-hour game development challenge to create a polished 2D autobattler.',
        modalDescription: [
          'For this 6-hour challenge, I developed the core AI and combat systems, including decision-making between attacking and resting, hit probabilities, and physical and magical attack stats.',
          'To create the 2D visuals, I rendered Mixamo characters and animations orthographically in Blender and integrated the resulting frame animations into Unity.',
          'I also added combat polish through camera shakes, color shifts, and custom particle effects for physical and magical attacks using Shader Graph.',
        ],
        url: '',
        actionLabel: 'View More',
        actionType: 'modal',
        modalKey: 'recruitmentChallenge',
      },
    ],
  },
  skills: {
    eyebrow: 'Expertise',
    title: 'Skills & Tools',
    categories: [
      { title: 'Game Development', items: ['Unity', 'Unity Gaming Services', 'Unreal Engine', 'C#', 'Git / GitHub'] },
      { title: 'Technical Art', items: ['Blender', 'Maya', 'ZBrush', 'Substance Painter', 'Shader Graph', 'VFX / Particle Systems', 'Materials & Shaders'] },
      { title: 'Design & UX/UI', items: ['Figma', 'Krita'] },
      { title: 'Web & Software Development', items: ['Python', 'JavaScript', 'React', 'Firebase', 'WordPress', 'Elementor'] },
      { title: 'Production & Collaboration', items: ['Jira', 'Microsoft Office'] },
    ],
  },
  contact: {
    eyebrow: 'Get In Touch',
    title: '',
    heading: "Let's Create Something Together",
    description: "I'm always open to new opportunities, collaborations and projects. Feel free to reach out.",
    socialLinks: [
      { label: 'Email', url: 'mailto:gfloresb09@gmail.com', icon: 'email' },
      { label: 'X', url: 'https://x.com/gfdevlab', icon: 'x' },
      { label: 'Instagram', url: 'https://www.instagram.com/gfdevlab/', icon: 'instagram' },
      { label: 'TikTok', url: 'https://www.tiktok.com/@gfdevlab', icon: 'tiktok' },
      { label: 'YouTube', url: 'https://www.youtube.com/@gfdevlab', icon: 'youtube' },
    ],
  },
};
